import { combineReducers } from 'redux';
import loading from './loading';
import languages from './languages';

export default combineReducers({
  loading,
  languages,
});
